// Permissible Actions

/*
 A list of levels to check against for certain actions.
 */
export const PERMISSION_LEVELS = {
  OWNED: 'OWNED', // This is for actions that can be performed at the account, org, or publisher level.
  GLOBAL_ORG: 'GLOBAL_ORG', // This is for actions that can be performed in the special Global Organization
  NO_CONTEXT: 'NO_CONTEXT', // This is for actions that can be performed without a context
  GROUP: 'GROUP', // This is for actions that are permissible on either the org or pub level, without needing distinction
  ORGANIZATION: 'ORGANIZATION',
  AD_ACCOUNT: 'AD_ACCOUNT',
  PUBLISHER: 'PUBLISHER',
  SNAP_PRO: 'SNAP_PRO',
};

export const GLOBAL_TEMPLATE_WRITE = {
  name: 'TEMPLATE_WRITE',
  requiredLevel: PERMISSION_LEVELS.GLOBAL_ORG,
};

export const GLOBAL_TEMPLATE_DELETE = {
  name: 'TEMPLATE_DELETE',
  requiredLevel: PERMISSION_LEVELS.GLOBAL_ORG,
};

export const TEMPLATE_WRITE = {
  name: 'TEMPLATE_WRITE',
  requiredLevel: PERMISSION_LEVELS.GROUP,
};

export const TEMPLATE_DELETE = {
  name: 'TEMPLATE_DELETE',
  requiredLevel: PERMISSION_LEVELS.GROUP,
};

export const SHARED_ASSET_WRITE = {
  name: 'SHARED_ASSET_WRITE',
  requiredLevel: PERMISSION_LEVELS.OWNED,
};

export const CREATIVE_READ = {
  name: 'CREATIVE_READ',
  requiredLevel: PERMISSION_LEVELS.OWNED,
};

export const CREATIVE_WRITE = {
  name: 'CREATIVE_WRITE',
  requiredLevel: PERMISSION_LEVELS.OWNED,
};

export const CREATIVE_DELETE = {
  name: 'CREATIVE_DELETE',
  requiredLevel: PERMISSION_LEVELS.OWNED,
};

export const CREATIVE_PUBLISH = {
  name: 'CREATIVE_PUBLISH',
  requiredLevel: PERMISSION_LEVELS.OWNED,
};

export const STOCK_ASSET_SEARCH = {
  name: 'STOCK_ASSET_SEARCH',
  requiredLevel: PERMISSION_LEVELS.NO_CONTEXT,
};
